@if (!isLoading) {
    <div>
        <form-linkable
            displayValueProp="name"
            [parentGuid]="parentGuid"
            [linkedModule]="linkedModule"
            [linkedForms]="linkedForms"
            [linked]="linked"
            [unlinked]="unlinked"
            [disabled]="disabled"
            [hideActions]="true"
            (linkedChange)="linkedItemsChanged($event)"
            data-uiid="thirdpartyforms-linkable"
        ></form-linkable>
    </div>
} @else {
    <div class="fancy-loader"></div>
}
